import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, withKeys as _withKeys, withModifiers as _withModifiers, isRef as _isRef, normalizeStyle as _normalizeStyle, resolveDynamicComponent as _resolveDynamicComponent, KeepAlive as _KeepAlive, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '../../assets/Group.png';
import _imports_1 from '../../assets/home/logoff.png';
const _withScopeId = n => (_pushScopeId("data-v-235197e9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "boxx"
};
const _hoisted_2 = {
  class: "common-layout",
  style: {
    "height": "100%"
  }
};
const _hoisted_3 = {
  class: "title"
};
const _hoisted_4 = {
  class: "img"
};
const _hoisted_5 = ["src"];
const _hoisted_6 = {
  class: "spanStyle"
};
const _hoisted_7 = ["aria-hidden"];
const _hoisted_8 = {
  class: "info"
};
const _hoisted_9 = {
  class: "BigScreenClass"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "大屏系统", -1));
const _hoisted_11 = ["onKeydown"];
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "应用商城", -1));
const _hoisted_13 = [_hoisted_12];
const _hoisted_14 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "帮助手册", -1));
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "helpStyle"
}, [/*#__PURE__*/_createElementVNode("span", null, "字体大小")], -1));
const _hoisted_16 = {
  class: "nameStyle"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));
const _hoisted_18 = {
  class: "delStyle"
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "退出", -1));
const _hoisted_21 = [_hoisted_19, _hoisted_20];
const _hoisted_22 = {
  class: "headerBox"
};
const _hoisted_23 = {
  class: "ExpandStyle"
};
const _hoisted_24 = {
  style: {
    "margin-left": "1.25rem"
  }
};
const _hoisted_25 = {
  style: {
    "display": "flex",
    "margin-bottom": "2rem"
  }
};
const _hoisted_26 = {
  style: {
    "display": "block",
    "width": "100%",
    "overflow": "hidden",
    "white-space": "nowrap",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_27 = {
  style: {
    "display": "block",
    "width": "100%",
    "overflow": "hidden",
    "white-space": "nowrap",
    "text-overflow": "ellipsis"
  }
};
const _hoisted_28 = {
  class: "contentDiv"
};
const _hoisted_29 = {
  class: "contentP"
};
const _hoisted_30 = {
  class: "contentStyle"
};
const _hoisted_31 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spanDivStyle"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "spanStyle"
}, "说明:")], -1));
const _hoisted_32 = ["innerHTML"];
const _hoisted_33 = {
  class: "videoStyle"
};
const _hoisted_34 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spanDivStyle"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "spanStyle"
}, "示例视频:")], -1));
const _hoisted_35 = {
  class: "videoDiv"
};
const _hoisted_36 = ["src"];
import { ref, reactive, onMounted, watch, nextTick, computed, onBeforeMount } from "vue";
import store from "@/store/index";
import { Search } from "@element-plus/icons-vue";
import Menu from "./Menu.vue";
import myDialog from "@/components/Tm-dialog.vue";
import { useRoute, useRouter } from "vue-router";
import session from "@/utils/storage/session.js";
import { logout, getList, menuTreeList, idByChildrenId } from "@/api/common";
import { Key, Cookie } from "@/utils/storage/cookie";
import libApi from "@/api/library/libraryCode";
import { Edit } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { setRouterAddrs } from "@/router";
import { cryptoEncryptionThird } from "@/utils/encryption";
import { QuestionFilled } from "@element-plus/icons-vue";
import Api from "@/api/library/appletManage/SystemConfig";
export default {
  __name: 'home',
  setup(__props) {
    const activeIn = ref(null);
    const route = useRoute();
    const menus = ref([]); // 从接口获取的菜单数据
    const visibleMenus = ref([]); // 显示的菜单项
    const hiddenMenus = ref([]); // 隐藏的菜单项
    const expandedItemId = ref(null); // 当前展开的一级子菜单ID
    const isCollapsedMenu = ref(false);
    const isScrollContainerHidden = computed(() => {
      // 根据业务逻辑判断是否需要隐藏滚动容器
      return false; // 默认不隐藏
    });

    const showHomeLanguageSwitch = computed(() => route.path === "/home/Welcome");
    let navList = ref([{
      cname: "首页",
      path: "/home/Welcome",
      icon: "HomeFilled",
      id: "1"
    }]);
    function filterHiddenRoutes2(routes) {
      return routes.filter(route => route.isHide === "0").map(route => {
        if (route?.ename !== undefined) {
          const lastSlashIndex = route.ename.lastIndexOf("/");
          if (lastSlashIndex !== -1) {
            // 如果找到了斜杠，提取最后一个斜杠后的部分
            const path = route.ename.substring(lastSlashIndex + 1);
            route.path = "/home/" + path;
          } else {
            // 如果没有找到斜杠，使用 cname 作为 path
            route.path = route.cname;
          }
        } else {
          // 如果 ename 未定义或为空，直接使用 cname 作为 path
          route.path = route.cname;
        }
        if (route.children && route.children.length > 0) {
          return {
            ...route,
            children: filterHiddenRoutes2(route.children)
          };
        }
        return route;
      });
    }
    const activePath = ref("");
    const handleSelect = index => {
      activeIn.value = index;
      const userInfo = Cookie.get(Key.userinfo);
      menuTreeList({
        userId: userInfo ? JSON.parse(userInfo)?.id : null,
        id: index
      }).then(response => {
        nextTick(() => {
          navList.value = [{
            cname: "首页",
            path: "/home/Welcome",
            icon: "HomeFilled",
            id: "1"
          }, ...filterHiddenRoutes2(response.data || [])];
        });
      }).catch(error => {});
      const oldIndex = Cookie.get("menuParentId");
      if (index != oldIndex) {
        activePath.value = "/home/Welcome";
        // routerData.value=[]
        // routerData.value.push({ name: '首页', path:'/home/Welcome', icon: 'HomeFilled',id:"1" });
        router.push({
          path: activePath.value
        }); // 使用 router.push 进行导航
        Cookie.set("menuParentId", index);
      }
    };
    const index = ref("");
    const fetchMenus = () => {
      menus.value = store.state.menuSourceList;
      console.log(menus.value, "menus.value");
      if (menus.value.length <= 7) {
        visibleMenus.value = menus.value;
        hiddenMenus.value = [];
      } else {
        visibleMenus.value = menus.value.slice(0, 7).map(item => ({
          ...item,
          id: item.id || "",
          // 确保 id 字段存在
          path: item.path || "" // 确保 path 字段存在
        }));

        hiddenMenus.value = menus.value.slice(7).map(item => ({
          ...item,
          id: item.id || "",
          path: item.path || ""
        }));
      }
      index.value = Cookie.get("menuParentId");
      if (index.value != null && index.value != "") {
        activeIn.value = index.value;
      } else {
        index.value = store.state.menuSourceList[0].index;
        activeIn.value = store.state.menuSourceList[0].index;
      }
      const userInfo = Cookie.get(Key.userinfo);
      menuTreeList({
        userId: userInfo ? JSON.parse(userInfo)?.id : null,
        id: index.value
      }).then(response => {
        nextTick(() => {
          navList.value = [{
            cname: "首页",
            path: "/home/Welcome",
            icon: "HomeFilled",
            id: "1"
          }, ...filterHiddenRoutes2(response.data || [])];
        });
      }).catch(error => {});
    };
    const router = useRouter(); //跳转
    const userinfo = reactive(JSON.parse(Cookie.get(Key.userinfo)));
    const canAccessApplicationMall = computed(() => store.state.routSet.includes("ApplicationMall"));
    const openApplicationMall = () => router.push("/home/ApplicationMall");
    function filterTree(tree) {
      const result = [];
      tree.forEach(node => {
        // 如果节点的 isHide 属性不存在，或者 hide == 0，则将其添加进新数组
        if (node.isHide === 0) {
          console.log(node);
          const newNode = {
            ...node,
            children: []
          }; // 复制节点，并清空 children
          if (node.children && node.children.length > 0) {
            newNode.children = filterTree(node.children); // 递归处理子节点
          }

          result.push(newNode);
        }
      });
      return result;
    }
    const routerData = computed(() => store.state.routerData);
    //动态缓存路由
    let keepAliveList = computed(() => {
      if (routerData.value.length == 0) {
        return ["Welcome"];
      }
      return routerData.value.map(item => item.path.replace("/home/", ""));
    });
    const isCollapsed = computed(() => store.state.isCollapsed);
    const path = ref(null);
    const showClick = () => {
      store.commit("SET_IS_COLLAPSED", !isCollapsed.value);
    };
    let fontSizeBtn = ref(store.state.fontSize);
    const handleOpen = (key, keyPath) => {};
    const handleClose = (key, keyPath) => {};
    function filterHiddenRoutes(routes) {
      return routes.filter(route => route.isHide === "0") // 只保留 isHide === "0" 的节点
      .map(route => {
        // 如果存在子节点，则递归处理它们
        if (route.children && route.children.length > 0) {
          return {
            ...route,
            children: filterHiddenRoutes(route.children) // 递归过滤子节点
          };
        }

        return route; // 返回当前符合条件的节点
      });
    }

    let providerSize = ref("default");
    const handleFontSizeCommand = command => {
      console.log("handleFontSizeCommand called with command:", command); // 添加日志
      // let fontSize = "16px"; // 默认中等字体
      store.commit("SET_FONT_SIZE", command);
      switch (command) {
        case "大":
          providerSize.value = "large";
          break;
        case "中":
          providerSize.value = "default";
          break;
        case "小":
          providerSize.value = "default";
          break;
      }
      // store.state.fontSize
      // providerSize.value = command;
      // 将字体大小保存到 localStorage
    };

    // 页面加载时从 localStorage 读取字体大小并应用
    onMounted(() => {
      loadLib();
      fetchMenus();
      getLibConfigs(userinfo.libid);
      const savedFontSize = localStorage.getItem("app-font-size");
      if (savedFontSize) {
        // document.documentElement.style.fontSize = savedFontSize;
        // store.commit("setFontSize", command);
        store.state.fontSizeMap.forEach(item => {
          if (item.size == savedFontSize) {
            store.commit("SET_FONT_SIZE", item.size);
            switch (item.size) {
              case "大":
                providerSize.value = "large";
                break;
              case "中":
                providerSize.value = "default";
                break;
              case "小":
                providerSize.value = "default";
                break;
            }
          }
        });
        console.log("默认有字体大小", savedFontSize); // 添加日志
      }
    });

    // 1. 定义一个响应式数组，用来存储查询结果
    const libConfig = ref({});
    // 2. 定义调用接口的方法
    const getLibConfigs = async libid => {
      try {
        console.log(libid);
        const res = await Api.listByLibId(libid);
        if (res.code == "200") {
          libConfig.value = res.data;
          // 1. 动态修改网页标题
          if (libConfig.value.systemName) {
            document.title = libConfig.value.systemName;
          }
          // 2. 动态修改 Favicon
          if (libConfig.value.logoIcon) {
            const link = document.querySelector("link[rel*='icon']") || document.createElement("link");
            link.type = "image/x-icon";
            link.rel = "shortcut icon";
            link.href = libConfig.value.logoIcon;
            document.getElementsByTagName("head")[0].appendChild(link);
          }
        } else {
          ElMessage.error(res.msg || "配置查询失败");
        }
      } catch (error) {
        console.error(error);
        ElMessage.error("配置接口请求异常");
      }
    };
    const handleCommand = type => {
      if (type == "c") {
        router.push("/home/ChangePassword");
      }
      if (type == "o") {
        router.push("/home/LibraryLocation");
      }
    };

    // 跳转到英文首页静态页面
    const goToEnglishHome = () => {
      window.location.href = "/static/en-us-home.html";
    };
    let helpContent = ref({});
    let activeIndex = ref("");
    let menuKey = ref(0);
    let isDrawer = ref(false);
    let isShow = ref(false);
    let titleName = ref("示例");
    let MenuList = ref([]);
    let bigScreenUrl = ref();
    const videoPlayer = ref(null);
    //帮助手册点击事件
    const helpClick = async () => {
      const res = await getList({
        homeQuery: true
      });
      if (res.status == 200) {
        MenuList.value = res.data.list;
        console.log(MenuList.value);
      }
      isDrawer.value = true;
    };
    const showMaskClose = () => {
      if (videoPlayer.value) {
        videoPlayer.value.pause(); // 停止视频播放
      }
    };

    let keyword = ref("");
    const findClick = async () => {
      const res = await getList({
        homeQuery: true,
        keyword: keyword.value
      });
      if (res.status == 200) {
        MenuList.value = res.data.list;
        activeIndex.value = " ";
        menuKey.value += 1;
        console.log(MenuList.value);
      }
    };
    //el-drawer的关闭事件
    const isClose = () => {
      activeIndex.value = " ";
      menuKey.value += 1;
      keyword.value = "";
    };
    //帮助手册 菜单的点击事件
    const helpMenuClick = val => {
      console.log(val);
      helpContent.value = val;
      titleName.value = val.title;
      isShow.value = true;
    };
    const loginout = async () => {
      // ElMessageBox.confirm(
      //   '是否确定退出登录?',
      //   '提示',
      //   {
      //     confirmButtonText: '确定',
      //     cancelButtonText: '取消',
      //     type: 'warning',
      //   }
      // )
      //   .then(async () => {
      const res = await logout();
      if (res.status == 200) {
        Cookie.remove(Key.token);
        //   sessionStorage.clear();
        //   localStorage.clear();
        //   Cookie.clearAll();
        sessionStorage.clear();
        store.dispatch("resetState");
        // ElMessage({
        //   type: 'success',
        //   message: res.data,
        // })
        // setTimeout(() => {
        if (localStorage.getItem("libid") == "JKQT") {
          router.replace("/JKlogin");
        } else if (localStorage.getItem("libid") == "YSXT") {
          router.replace("/YSlogin");
        } else if (localStorage.getItem("libid") == "GXQT") {
          router.replace("/GXlogin");
        } else {
          router.replace("/login");
        }
        // }, 500);
      }
      // })
    };

    const delClick = async () => {
      console.log(Cookie);
      const res = await logout();
      if (res.status == 200) {
        sessionStorage.clear();
        // localStorage.clear();
        Cookie.clearAll();
        sessionStorage.clear();
        // 遍历localStorage，清除除了libid之外的所有数据
        for (let i = localStorage.length - 1; i >= 0; i--) {
          const key = localStorage.key(i);
          if (key !== "libid") {
            localStorage.removeItem(key);
          }
        }
        store.dispatch("resetState");
        if (localStorage.getItem("libid") == "JKQT") {
          router.replace("/JKlogin");
        } else if (localStorage.getItem("libid") == "YSXT") {
          router.replace("/YSlogin");
        } else if (localStorage.getItem("libid") == "GXQT") {
          router.replace("/GXlogin");
        } else {
          router.replace("/login");
        }
        window.location.reload();
      } else {
        if (localStorage.getItem("libid") == "JKQT") {
          router.replace("/JKlogin");
        } else if (localStorage.getItem("libid") == "YSXT") {
          router.replace("/YSlogin");
        } else if (localStorage.getItem("libid") == "GXQT") {
          router.replace("/GXlogin");
        } else {
          router.replace("/login");
        }
        window.location.reload();
      }
    };
    function getLastPartOfPath(path) {
      return path && typeof path === "string" ? path.split("/").pop() : "";
    }
    watch(() => router.currentRoute.value, toPath => {
      activePath.value = toPath.path;
      path.value = toPath.path;
      if (routerData.value && routerData.value.length > 0) {
        let flag = routerData.value.some(item => item.path === toPath.path);
        if (!flag) {
          routerData.value.push({
            name: toPath.meta.title,
            path: toPath.path
          });
        }
      } else {
        routerData.value.push({
          name: toPath.meta.title,
          path: toPath.path
        });
        activePath.value = toPath.path;
      }
    }, {
      immediate: true,
      deep: true
    });
    const tagHandlClcik = data => {
      router.push(data.path);
    };
    const tagHandleClose = (data, index) => {
      store.commit("removeRouterData", data.path);
      const newRouterData = store.state.routerData;
      if (data.path == path.value) {
        if (newRouterData.length > 1) {
          const goIndex = index - 1 >= 0 ? index - 1 : 0;
          router.push(newRouterData[goIndex].path);
        } else {
          router.push("/home/Welcome");
        }
      }
    };
    const closeAll = () => {
      let val = [{
        name: "首页",
        path: "/home/Welcome"
      }];
      store.commit("setRouterData", val);
      router.push("/home/Welcome");
    };
    const icaifang = () => {
      // applyUrl = "https://jxtmkj.icaifang.cn";
      libApi.LogToMaiDa({
        applyUrl: "https://jxtmkj.icaifang.cn"
      }).then(response => {
        if (response.status == 200) {
          console.log(response);
          window.open("https://jxtmkj.icaifang.cn");
        }
      });
    };
    const relocation = async () => {
      let token = Cookie.get(Key.token);
      window.open(bigScreenUrl.value + "/home/Welcome?auth_token=" + token);
    };
    const loadLib = async () => {
      let libid = userinfo.libid;
      let res = await libApi.getBigScreenUrl({
        libId: libid
      });
      if (res.status == 200 && res.data) {
        bigScreenUrl.value = res.data.bigScreenUrl;
      } else {
        console.log("关联大屏失败！");
      }
    };
    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_link = _resolveComponent("el-link");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_radio_button = _resolveComponent("el-radio-button");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_Delete = _resolveComponent("Delete");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_header = _resolveComponent("el-header");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_Expand = _resolveComponent("Expand");
      const _component_Fold = _resolveComponent("Fold");
      const _component_el_tag = _resolveComponent("el-tag");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_button = _resolveComponent("el-button");
      const _component_location = _resolveComponent("location");
      const _component_el_menu_item_group = _resolveComponent("el-menu-item-group");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_el_empty = _resolveComponent("el-empty");
      const _component_el_drawer = _resolveComponent("el-drawer");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_config_provider = _resolveComponent("el-config-provider");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_container, null, {
        default: _withCtx(() => [_createVNode(_component_el_header, {
          class: "haederStyle"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("img", {
            class: "logo",
            src: libConfig.value.logo,
            alt: "",
            style: {
              "height": "auto"
            }
          }, null, 8, _hoisted_5)]), _createElementVNode("span", _hoisted_6, _toDisplayString(libConfig.value.systemName), 1), _createVNode(_component_el_menu, {
            "default-active": activeIn.value,
            style: {
              "max-width": "60rem"
            },
            class: "elmenu",
            ellipsis: hiddenMenus.value.length > 0 && menus.value.length > 7 ? true : false,
            mode: "horizontal",
            onSelect: handleSelect
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleMenus.value, item => {
              return _openBlock(), _createBlock(_component_el_menu_item, {
                key: item.index,
                index: item.index,
                class: _normalizeClass({
                  active: activeIn.value === item.index
                }),
                style: {
                  "font-size": "1.15rem"
                }
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.label), 1)]),
                _: 2
              }, 1032, ["index", "class"]);
            }), 128)), hiddenMenus.value.length > 0 && menus.value.length > 7 ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "scroll-container",
              "aria-hidden": isScrollContainerHidden.value
            }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(hiddenMenus.value, i => {
              return _openBlock(), _createBlock(_component_el_menu_item, {
                key: i.index,
                index: i.index,
                style: {
                  "font-size": "1.15rem"
                },
                class: _normalizeClass({
                  active2: activeIn.value === i.id
                })
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(i.label), 1)]),
                _: 2
              }, 1032, ["index", "class"]);
            }), 128))], 8, _hoisted_7)) : _createCommentVNode("", true)]),
            _: 1
          }, 8, ["default-active", "ellipsis"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_unref(bigScreenUrl) ? (_openBlock(), _createBlock(_component_el_link, {
            key: 0,
            type: "primary",
            underline: false,
            icon: _unref(Edit),
            class: "linkClass",
            onClick: relocation
          }, {
            default: _withCtx(() => [_hoisted_10]),
            _: 1
          }, 8, ["icon"])) : _createCommentVNode("", true)]), canAccessApplicationMall.value ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "helpStyle applicationMallStyle",
            role: "button",
            tabindex: "0",
            onClick: openApplicationMall,
            onKeydown: [_withKeys(openApplicationMall, ["enter"]), _withKeys(_withModifiers(openApplicationMall, ["prevent"]), ["space"])]
          }, _hoisted_13, 40, _hoisted_11)) : _createCommentVNode("", true), _createElementVNode("div", {
            class: "helpStyle",
            onClick: helpClick
          }, [_hoisted_14, _createVNode(_component_el_icon, null, {
            default: _withCtx(() => [_createVNode(_unref(QuestionFilled))]),
            _: 1
          })]), _createVNode(_component_el_dropdown, {
            trigger: "click"
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, {
              class: "font-size-dropdown-menu"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: _unref(fontSizeBtn),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _isRef(fontSizeBtn) ? fontSizeBtn.value = $event : fontSizeBtn = $event)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(store).state.fontSizeMap, item => {
                  return _openBlock(), _createBlock(_component_el_radio_button, {
                    onClick: $event => handleFontSizeCommand(item.size),
                    key: item.size,
                    value: item.size
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(item.size), 1)]),
                    _: 2
                  }, 1032, ["onClick", "value"]);
                }), 128))]),
                _: 1
              }, 8, ["modelValue"])]),
              _: 1
            })]),
            default: _withCtx(() => [_hoisted_15]),
            _: 1
          }), _createVNode(_component_el_dropdown, {
            onCommand: handleCommand
          }, {
            dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                command: "a"
              }, {
                default: _withCtx(() => [_createTextVNode("账号：" + _toDisplayString(userinfo.loginName), 1)]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                command: "l"
              }, {
                default: _withCtx(() => [_createTextVNode("所属馆：" + _toDisplayString(userinfo.libName), 1)]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                command: "o"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_link, {
                  type: "primary",
                  command: "o"
                }, {
                  default: _withCtx(() => [_createTextVNode("馆藏地：" + _toDisplayString(userinfo.localName), 1)]),
                  _: 1
                })]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                command: "r"
              }, {
                default: _withCtx(() => [_createTextVNode("角色：" + _toDisplayString(userinfo.cname), 1)]),
                _: 1
              }), _createVNode(_component_el_dropdown_item, {
                command: "c"
              }, {
                default: _withCtx(() => [_createVNode(_component_el_link, {
                  type: "primary",
                  command: "c"
                }, {
                  default: _withCtx(() => [_createTextVNode("个人中心")]),
                  _: 1
                })]),
                _: 1
              })]),
              _: 1
            })]),
            default: _withCtx(() => [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("span", null, _toDisplayString(userinfo.name), 1)])]),
            _: 1
          }), _createElementVNode("div", _hoisted_18, [_createVNode(_component_el_popover, {
            placement: "bottom",
            title: "提示",
            width: "12.5rem",
            trigger: "hover",
            content: "清除缓存",
            "popper-class": "del-popover"
          }, {
            reference: _withCtx(() => [_createVNode(_component_el_icon, {
              class: "del-icon",
              onClick: _withModifiers(delClick, ["stop"]),
              size: "1.25rem",
              color: "#fff"
            }, {
              default: _withCtx(() => [_createVNode(_component_Delete)]),
              _: 1
            }, 8, ["onClick"])]),
            _: 1
          })]), _createElementVNode("div", {
            class: "offStyle",
            onClick: loginout
          }, _hoisted_21)])]),
          _: 1
        }), _createVNode(_component_el_container, {
          class: "main"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_aside, {
            width: "auto"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_menu, {
              "default-active": activePath.value,
              "collapse-transition": true,
              collapse: isCollapsed.value,
              router: "",
              "unique-opened": "",
              class: "el-menu-vertical-demo menuStyle",
              "background-color": "transparent",
              "active-text-color": "#3888f5",
              "text-font-size": "20px",
              "text-color": "#FFFFFF",
              onOpen: handleOpen,
              onClose: handleClose
            }, {
              default: _withCtx(() => [_createVNode(Menu, {
                collapse: isCollapsed.value,
                data: _unref(navList)
              }, null, 8, ["collapse", "data"])]),
              _: 1
            }, 8, ["default-active", "collapse"])]),
            _: 1
          }), _createVNode(_component_el_main, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [isCollapsed.value ? (_openBlock(), _createBlock(_component_el_icon, {
              key: 0,
              color: "#2679ee",
              onClick: showClick,
              size: "1.5625rem"
            }, {
              default: _withCtx(() => [_createVNode(_component_Expand)]),
              _: 1
            })) : (_openBlock(), _createBlock(_component_el_icon, {
              key: 1,
              color: "#2679ee",
              onClick: showClick,
              size: "1.5625rem"
            }, {
              default: _withCtx(() => [_createVNode(_component_Fold)]),
              _: 1
            }))]), _createElementVNode("div", _hoisted_24, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(routerData.value, (item, index) => {
              return _openBlock(), _createBlock(_component_el_tag, {
                class: "elTag",
                size: "large",
                key: index,
                color: "#2148ac",
                to: {
                  path: item.path
                },
                style: _normalizeStyle({
                  color: path.value == item.path ? '#fff' : '#fff',
                  background: path.value == item.path ? ' #314be7' : '#4983fc'
                }),
                closable: item.name == '首页' ? false : true,
                onClose: $event => tagHandleClose(item, index),
                onClick: $event => tagHandlClcik(item)
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(item.name), 1)]),
                _: 2
              }, 1032, ["to", "style", "closable", "onClose", "onClick"]);
            }), 128))]), _createElementVNode("div", null, [routerData.value.length > 1 ? (_openBlock(), _createBlock(_component_el_tag, {
              key: 0,
              class: "clearAll",
              type: "primary",
              effect: "dark",
              onClick: _cache[1] || (_cache[1] = $event => closeAll())
            }, {
              default: _withCtx(() => [_createTextVNode("关闭所有")]),
              _: 1
            })) : _createCommentVNode("", true)])]), _createVNode(_component_el_drawer, {
              modelValue: _unref(isDrawer),
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _isRef(isDrawer) ? isDrawer.value = $event : isDrawer = $event),
              onClose: isClose,
              "with-header": false,
              direction: "rtl",
              size: "20rem",
              style: {
                "display": "flex",
                "align-items": "center",
                "justify-content": "center"
              }
            }, {
              default: _withCtx(() => [_createElementVNode("div", _hoisted_25, [_createVNode(_component_el_input, {
                modelValue: _unref(keyword),
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _isRef(keyword) ? keyword.value = $event : keyword = $event),
                class: "inputStyle",
                clearable: "",
                style: {
                  "width": "12.5rem",
                  "margin-right": "0rem"
                },
                placeholder: "请输入搜索内容",
                "prefix-icon": _unref(Search)
              }, null, 8, ["modelValue", "prefix-icon"]), _createVNode(_component_el_button, {
                type: "primary",
                onClick: findClick
              }, {
                default: _withCtx(() => [_createTextVNode("搜索")]),
                _: 1
              })]), _unref(MenuList).length > 0 ? (_openBlock(), _createBlock(_component_el_menu, {
                class: "el-menu-vertical-demo",
                "unique-opened": "true",
                "default-active": _unref(activeIndex),
                key: _unref(menuKey)
              }, {
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(MenuList), (item, index) => {
                  return _openBlock(), _createElementBlock(_Fragment, null, [item.children && item.children?.length > 0 ? (_openBlock(), _createBlock(_component_el_sub_menu, {
                    index: index,
                    key: index
                  }, {
                    title: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_component_location)]),
                      _: 1
                    }), _createElementVNode("span", _hoisted_26, _toDisplayString(item.name), 1)]),
                    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (citem, cindex) => {
                      return _openBlock(), _createBlock(_component_el_menu_item_group, {
                        key: cindex
                      }, {
                        default: _withCtx(() => [_createVNode(_component_el_menu_item, {
                          onClick: $event => helpMenuClick(citem),
                          index: index - cindex
                        }, {
                          default: _withCtx(() => [_createTextVNode(_toDisplayString(citem.title), 1)]),
                          _: 2
                        }, 1032, ["onClick", "index"])]),
                        _: 2
                      }, 1024);
                    }), 128))]),
                    _: 2
                  }, 1032, ["index"])) : (_openBlock(), _createBlock(_component_el_menu_item, {
                    key: 1,
                    index: index
                  }, {
                    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [_createVNode(_component_location)]),
                      _: 1
                    }), _createElementVNode("span", _hoisted_27, _toDisplayString(item.name), 1)]),
                    _: 2
                  }, 1032, ["index"]))], 64);
                }), 256))]),
                _: 1
              }, 8, ["default-active"])) : (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                description: "暂无数据"
              }))]),
              _: 1
            }, 8, ["modelValue"]), _createVNode(myDialog, {
              isShow: _unref(isShow),
              "onUpdate:isShow": _cache[4] || (_cache[4] = $event => _isRef(isShow) ? isShow.value = $event : isShow = $event),
              isFooter: false,
              class: "isDialog",
              footerAlign: "center",
              width: "80rem",
              title: _unref(titleName),
              onClose: showMaskClose
            }, {
              dialogBody: _withCtx(() => [_createElementVNode("div", _hoisted_28, [_createElementVNode("p", _hoisted_29, _toDisplayString(_unref(helpContent).title), 1), _createElementVNode("div", _hoisted_30, [_hoisted_31, _createElementVNode("div", {
                class: "contentDivStyle",
                innerHTML: _unref(helpContent).content
              }, null, 8, _hoisted_32)]), _createElementVNode("div", _hoisted_33, [_hoisted_34, _createElementVNode("div", _hoisted_35, [_createElementVNode("video", {
                ref_key: "videoPlayer",
                ref: videoPlayer,
                src: _unref(helpContent).url + _unref(helpContent).videoUrl,
                height: "500",
                preload: "auto",
                controls: "controls"
              }, null, 8, _hoisted_36)])])])]),
              _: 1
            }, 8, ["isShow", "title"]), _createVNode(_component_el_config_provider, {
              size: _unref(providerSize)
            }, {
              default: _withCtx(() => [_createVNode(_component_router_view, null, {
                default: _withCtx(({
                  Component
                }) => [(_openBlock(), _createBlock(_KeepAlive, {
                  include: _unref(keepAliveList)
                }, [(_openBlock(), _createBlock(_resolveDynamicComponent(Component)))], 1032, ["include"]))]),
                _: 1
              })]),
              _: 1
            }, 8, ["size"])]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })])]);
    };
  }
};